// src/platform/platform.ts
// Central platform detection — import this everywhere instead of checking navigator.userAgent

import { Capacitor } from '@capacitor/core';

export const isNative = (): boolean => Capacitor.isNativePlatform();
export const isWeb = (): boolean => !isNative();
export const getPlatform = (): 'ios' | 'android' | 'web' => Capacitor.getPlatform() as 'ios' | 'android' | 'web';
export const isIos = (): boolean => getPlatform() === 'ios';
export const isAndroid = (): boolean => getPlatform() === 'android';
